import { render, staticRenderFns } from "./SvlpSucursalVirtualComponent.vue?vue&type=template&id=52bb12cc&scoped=true"
import script from "./SvlpSucursalVirtualComponent.vue?vue&type=script&lang=js"
export * from "./SvlpSucursalVirtualComponent.vue?vue&type=script&lang=js"
import style0 from "./SvlpSucursalVirtualComponent.vue?vue&type=style&index=0&id=52bb12cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb12cc",
  null
  
)

export default component.exports